import { logger } from 'shared/lib'
import { ComplianceApi } from 'entities/Compliance/api/compliance'

const checkSingleUrl = async (url: string) => {
  try {
    const { data } = await ComplianceApi.onlineFormUrlCheck({ onlineFormUrl: url })
    return { url: url, reachable: data.reachable }
  } catch (error) {
    logger.error(error)
    return { url: url, reachable: false }
  }
}

export const complianceCheckUrl = async (url: string) => {
  const isBaseUrlHasProtocol = url.startsWith('http://') || url.startsWith('https://')

  try {
    if (isBaseUrlHasProtocol) {
      const result = await checkSingleUrl(url)
      if (result.reachable) {
        return url
      }
    } else {
      const httpUrl = `http://${url}`
      const httpsUrl = `https://${url}`

      const [httpsResult, httpResult] = await Promise.allSettled([
        checkSingleUrl(httpsUrl),
        checkSingleUrl(httpUrl),
      ])

      const httpsReachable = httpsResult.status === 'fulfilled' && httpsResult.value.reachable
      const httpReachable = httpResult.status === 'fulfilled' && httpResult.value.reachable

      if (httpsReachable) {
        return httpsUrl
      } else if (httpReachable) {
        return httpUrl
      }
    }
  } catch (error) {
    logger.error(error)
  }

  return false
}
